<script setup lang="ts">
import { Textarea } from '~ds/components/ui/textarea';
import { Heading } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

import type { FeedbackSurveyQuestionTextarea } from './types';

import { feedbackQuestionLabel } from './types';

const props = defineProps<{
  question: FeedbackSurveyQuestionTextarea;
}>();

const model = defineModel<string | undefined>({ default: '' });
const { t } = useI18n();

const label = computed(() => feedbackQuestionLabel(props.question, t));
</script>

<template>
  <div class="flex flex-col items-center gap-6">
    <Heading
      size="md"
      as="h3"
      class="text-center max-w-sm"
    >
      {{ label }}
    </Heading>
    <div class="w-full max-w-xl">
      <Textarea
        :model-value="model"
        :aria-label="label"
        :required="question.required"
        maxlength="2000"
        rows="8"
        class="min-h-48"
        @update:model-value="model = String($event)"
      />
    </div>
  </div>
</template>
